import { TrainingFile } from "@/features/training/model/Training/TrainingFile";

import { UserSummary } from "@/model/User/UserSummary";

export class TrainingDrill {
	Id: number;
	Name: string;
	Description: string;
	Trainer: UserSummary;
	Attachments: TrainingFile[];
	Sessions: Session[];
	FolderId: number;
	KpiParameters: SessionKpi[];
	Type: SessionType;
}

class Session {
	Id: number;
	Name: string;
	Date: string;
}

class SessionKpi {
	Id: number;
	Name: string;
	MaxValue: number;
	Value?: number;
}

export enum SessionType {
	Course = "Course",
	Exercise = "Exercise",
	Event = "Event",
}

export class TrainingDrillRequest {
	Name: string;
	Description: string;
	TrainerId: number;
	FolderId: number;
	AttachmentIds: number[];
	KpiIds: number[];
	Type: string;
}
